import React from 'react';
import { useDispatch } from 'react-redux';

import { showToast } from '../../../helpers/toastHelper';
import OvalPoliciesNew from './OvalPoliciesNew';

const WrappedOvalPoliciesNew = props => (
  <OvalPoliciesNew {...props} showToast={showToast(useDispatch())} />
);

export default WrappedOvalPoliciesNew;



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_openscap-5.2.2-2.fm3_3.el8.noarch/usr/share/gems/gems/foreman_openscap-5.2.2/webpack/routes/OvalPolicies/OvalPoliciesNew/index.js